/** @jsxImportSource @emotion/react */

import { FC, ReactNode, useEffect, useRef } from "react";
import Header, { headerHeight } from "./components/Header";
import { useUIStore } from "../../hooks/useUIStore";
import UserProfileModal from "../Modal/userProfile";

interface LayoutProps {
  children: ReactNode;
  useFullHeight?: boolean;
}

const Layout: FC<LayoutProps> = ({ children, useFullHeight }) => {
  const {
    isProfileModalOpen,
    closeProfileModal,
    isNewMessageOpen,
    closeNewMessage,
    closeDrawer,
  } = useUIStore();
  const ref: any = useRef(null);

  // close the profile modal when clicked outside
  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      // If the profile modal is open and the clicked target is not within the modal,
      // then close the modal
      if (
        isProfileModalOpen &&
        isNewMessageOpen &&
        !ref.current.contains(e.target)
      ) {
        closeProfileModal();
        closeNewMessage();
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    document.addEventListener("mousedown", closeNewMessage);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
      document.removeEventListener("mousedown", closeNewMessage);
    };
  }, [isProfileModalOpen, isNewMessageOpen]);

  // make sure drawer is closed to avoid maintaining opacity on cards
  useEffect(() => {
    closeDrawer();
  }, []);

  return (
    <>
      <Header />
      <div
        css={{
          height: useFullHeight ? "100%" : `calc(100vh - ${headerHeight}px)`,
          padding: 20,
          boxSizing: "border-box",
        }}
      >
        <UserProfileModal
          onRef={ref}
          show={isProfileModalOpen}
          onClose={closeProfileModal}
        />
        {children}
      </div>
    </>
  );
};

export default Layout;
